import {
  Box,
  Flex,
  Heading,
  IconButton,
  Input,
  CloseButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useDisclosure,
  Button,
  Text,
  InputGroup,
  InputRightElement,
  Link,
  ModalHeader,
  ModalFooter,
  VStack,
  SimpleGrid,
  Table,
  Thead,
  Th,
  Tbody,
  Tr,
  Td,
  ButtonGroup,
  Badge,
  Select,
  Toast,
  useToast,
} from "@chakra-ui/react";
import { crm } from "../../../theme";
import { DateTime } from "luxon";
import {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useState,
} from "react";
import { FaCircle, FaDownload, FaSearch, FaUpload } from "react-icons/fa";
import {
  getLastProspect,
  saveProspect,
} from "../../../services/prospectService";
import SearchableSelect from "../../../components/SearchableSelect";
import { CompanyFormData } from "../../Configurations/tabs/types";
import { getCompanies } from "../../../services/companyService";
import { useCompany } from "../../../contexts/CompanyContext";
import { useNavigate } from "react-router-dom";
import CompanyForm from "../../Configurations/tabs/Company/components/CompanyForm";

const CreateProspectModal = ({
  isOpen,
  onClose,
  get,
}: {
  get: () => Promise<any>;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const [clients, setClients] = useState<CompanyFormData[]>([]);
  const [status, setStatus] = useState("Pendente");
  const [loading, setLoading] = useState(false);
  const [clientId, setClientId] = useState<string>();
  const [add, setAdd] = useState(false);
  const { currentCompany } = useCompany();
  const toast = useToast();
  const [prospectNumber, setProspectNumber] = useState(1);
  const create = async () => {
    try {
      setLoading(true);
      const response = await saveProspect({
        clientId,
        status,
      });
      if (response?.data.success) {
        toast({
          title: "Cliente criado.",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
        onClose();
        await get();
      } else {
        toast({
          title: response?.data.notifications?.[0],
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: "Erro ao criar cliente.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };
  const fetchData = useCallback(async () => {
    try {
      const data = await getLastProspect();
      setProspectNumber(data);
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    fetchData();

    const intervalId = setInterval(() => {
      fetchData();
    }, 10000);

    return () => {
      clearInterval(intervalId);
    };
  }, [fetchData]);

  const getClients = async () => {
    const response = await getCompanies(false, currentCompany);
    if (response) setClients(response);
  };
  useEffect(() => {
    getClients();
  }, [currentCompany]);
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size={add ? "5xl" : undefined}
      scrollBehavior="inside"
    >
      <ModalOverlay backdropFilter="blur(2px)" bg="blackAlpha.600" />
      <ModalContent borderRadius="16px" boxShadow="0 12px 32px rgba(16,24,40,0.18)">
        <ModalHeader>
          <Flex justifyContent="space-between">
            <Heading size="md" fontWeight="semibold">
              Criar prospect nº {prospectNumber + 1}
            </Heading>
            <CloseButton onClick={onClose} />
          </Flex>
        </ModalHeader>
        <ModalBody>
          <Box padding="24px">
            {clients && (
              <>
                <Heading size="sm" fontWeight="semibold" mb="8px">
                  Selecione o cliente para o prospect
                </Heading>
                <SearchableSelect
                  placeholder="Selecione um cliente"
                  backgroundColor="white"
                  options={[
                    ...clients.map((c) => ({
                      value: c.id,
                      label: c.name,
                      subLabel: c.cnpj,
                    })),
                  ]}
                  defaultSelectValue={
                    clients
                      ?.filter((c) => c.id === clientId)
                      ?.map((c) => ({
                        value: c.id,
                        label: c.name,
                        subLabel: c.cnpj,
                      }))[0] ?? undefined
                  }
                  name="clientId"
                  setValue={(value) => {
                    setClientId(value);
                  }}
                />
                <Flex my="32px" alignItems="center" gap="4px" fontSize="sm">
                  <Text>Não encontrou o cliente que precisa?</Text>
                  <Text
                    as="span"
                    onClick={() => setAdd(true)}
                    cursor="pointer"
                    color={crm.brand}
                    fontWeight="600"
                  >
                    Criar um novo
                  </Text>
                </Flex>
                <Heading size="sm" fontWeight="semibold" mt="32px" mb="8px">
                  Status
                </Heading>
                <Select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="Pendente">Pendente</option>
                  <option value="Ativo">Ativo</option>
                  <option value="Inativo">Inativo</option>
                </Select>
              </>
            )}
            {add && (
              <CompanyForm
                get={getClients}
                set={setAdd}
                setClientId={setClientId}
              />
            )}
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flex justifyContent="space-between" w="100%">
            <Button
              w="100px"
              onClick={onClose}
              variant="outline"
              borderColor={crm.border}
              color={crm.textMuted}
              borderRadius="10px"
              _hover={{ bg: crm.brandSoft }}
            >
              Cancelar
            </Button>
            <Button
              isLoading={loading}
              isDisabled={!clientId}
              w="100px"
              bg={crm.brand}
              color="white"
              borderRadius="10px"
              _hover={{ bg: crm.brandDark }}
              onClick={() => create()}
            >
              Criar
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default CreateProspectModal;
